/**
 * Get the day number from a date in format YYYY-MM-DD
 */
export function getColumnIndexFromDate({ date = "" } = {}) {
  // return date === "total" ? "total" : date?.split("-")?.[2];
  return date?.split("-")?.[2];
}
